import classes from '../ccf-call-conference.module.scss';
import {
  Card,
  CardHeader,
  CardContent,
  MenuItem,
  Box,
  Divider,
} from '@mui/material';
import {
  CcfHeader,
  CcfCallConferenceIcon,
  CcfConsultIcon,
  useTranslator,
  CcfTypography,
  CcfPinControlIcon,
  CcfDockControlIcon,
  CcfMessageOutlineIcon,
  CcfMailOutlineIcon,
  CcfAddChannelIcon,
} from '@nice-ccf/ui-controls';
import { useSelector, useDispatch } from 'react-redux';
import {
  activeContactSelector,
  setIsDocked,
} from '../../ccf-inbox/ccf-inbox.slice';
import {
  selectCallConferenceTitleText,
  selectCallConferenceStatus,
} from '../ccf-call-conference.slice';

/**
 * Component to be used for user conference header
 * @example <UserConferenceHeader />
 * @returns
 */
export const UserConferenceHeader = () => {
  const [translate] = useTranslator();
  const dispatch = useDispatch();
  const text = useSelector(selectCallConferenceTitleText) as
    | 'Conference'
    | 'Consult';
  const status = useSelector(selectCallConferenceStatus);
  const selectedCallContact = useSelector(activeContactSelector);

  /**
   * @example dockContainer()
   */
  function dockContainer() {
    if (selectedCallContact && selectedCallContact.id)
      dispatch(setIsDocked({ id: selectedCallContact.id, isDocked: true }));
  }

  /**
   * @example pinContainer()
   */
  function pinContainer() {
    if (selectedCallContact && selectedCallContact.id)
      dispatch(setIsDocked({ id: selectedCallContact.id, isDocked: false }));
  }

  return (
    <CcfHeader
      headerText={translate(text)}
      headerTextClassess={classes.marginLeft}
      LeftIcon={
        status === 'conference' ? (
          <CcfCallConferenceIcon
            classes={{ root: classes.marginLeft }}
            htmlColor="#526B7A"
          />
        ) : (
          <CcfConsultIcon
            htmlColor="#526B7A"
            viewBox="0 0 20 20"
            classes={{ root: `${classes.headerIcon} ${classes.marginLeft}` }}
          />
        )
      }
      RightIcon
      PopoverContent={
        <Card classes={{ root: classes.callConferenceHeader }}>
          <CardHeader
            classes={{ root: classes.header }}
            title={
              <CcfTypography
                translationKey="controlPosition"
                classes={{ root: classes.headerTitle }}
              />
            }
          />
          <CardContent classes={{ root: `${classes.headerContent}` }}>
            {selectedCallContact && selectedCallContact.isDocked ? (
              <MenuItem
                onClick={pinContainer}
                classes={{ root: classes.headerContentMenuItem }}
              >
                <CcfPinControlIcon
                  htmlColor="#526b7a"
                  classes={{ root: classes.headerContentMenuItemIcon }}
                ></CcfPinControlIcon>
                <CcfTypography
                  translationKey="pinControls"
                  classes={{ root: classes.headerContentMenuItemTypography }}
                />
              </MenuItem>
            ) : (
              <MenuItem
                onClick={dockContainer}
                classes={{ root: classes.headerContentMenuItem }}
              >
                <CcfDockControlIcon
                  htmlColor="#526b7a"
                  classes={{ root: classes.headerContentMenuItemIcon }}
                />
                <CcfTypography
                  translationKey="dockControls"
                  classes={{ root: classes.headerContentMenuItemTypography }}
                />
              </MenuItem>
            )}
            <Box display="flex" alignItems="center">
              <CcfTypography
                translationKey="addChannel"
                style={{ fontSize: 'small', margin: '4px 2px 4px 8px' }}
              />
              <Box flex="1">
                <Divider />
              </Box>
            </Box>
            <MenuItem classes={{ root: classes.headerContentMenuItem }}>
              <CcfMessageOutlineIcon
                htmlColor="#526b7a"
                classes={{ root: classes.headerContentMenuItemIcon }}
              />
              <CcfTypography
                translationKey="sms"
                classes={{ root: classes.headerContentMenuItemTypography }}
              />
            </MenuItem>
            <MenuItem classes={{ root: classes.headerContentMenuItem }}>
              <CcfMailOutlineIcon
                htmlColor="#526b7a"
                classes={{ root: classes.headerContentMenuItemIcon }}
              />
              <CcfTypography
                translationKey="email"
                classes={{ root: classes.headerContentMenuItemTypography }}
              />
            </MenuItem>
            <MenuItem classes={{ root: classes.headerContentMenuItem }}>
              <CcfAddChannelIcon
                htmlColor="#526b7a"
                classes={{ root: classes.headerContentMenuItemIcon }}
              />
              <CcfTypography
                translationKey="addNewChannel"
                classes={{ root: classes.headerContentMenuItemTypography }}
              />
            </MenuItem>
          </CardContent>
        </Card>
      }
      PopoverContentProps={{ dismissable: true }}
    />
  );
};
